/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_AccountingInputs */

const en_admin_resource_form_accounting = /** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accounting`)
};

const de_admin_resource_form_accounting = /** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchhaltung`)
};

const es_admin_resource_form_accounting = /** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contabilidad`)
};

const fr_admin_resource_form_accounting = /** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comptabilité`)
};

const nl_admin_resource_form_accounting = /** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boekhouding`)
};

/** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */
const it_admin_resource_form_accounting = en_admin_resource_form_accounting;

/** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */
const pt_br2_admin_resource_form_accounting = en_admin_resource_form_accounting;

/** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */
const pl_admin_resource_form_accounting = en_admin_resource_form_accounting;

/** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */
const hu_admin_resource_form_accounting = en_admin_resource_form_accounting;

/** @type {(inputs: Admin_Resource_Form_AccountingInputs) => LocalizedString} */
const ro_admin_resource_form_accounting = en_admin_resource_form_accounting;

/**
* | output |
* | --- |
* | "Accounting" |
*
* @param {Admin_Resource_Form_AccountingInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_accounting = /** @type {((inputs?: Admin_Resource_Form_AccountingInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_AccountingInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_accounting(inputs)
	if (locale === "de") return de_admin_resource_form_accounting(inputs)
	if (locale === "es") return es_admin_resource_form_accounting(inputs)
	if (locale === "fr") return fr_admin_resource_form_accounting(inputs)
	if (locale === "nl") return nl_admin_resource_form_accounting(inputs)
	if (locale === "it") return it_admin_resource_form_accounting(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_accounting(inputs)
	if (locale === "pl") return pl_admin_resource_form_accounting(inputs)
	if (locale === "hu") return hu_admin_resource_form_accounting(inputs)
	return ro_admin_resource_form_accounting(inputs)
});
export { admin_resource_form_accounting as "admin.resource_form.accounting" }